import styled, { keyframes } from 'styled-components';
import { shade } from 'polished';
import { device } from 'styles/device';
import Row from 'react-bootstrap/Row';

export const ContainerStyled = styled.div`
  label {
    margin-bottom: 0;
  }

  .col-md-auto {
    padding: 0px opx;
  }
  .container {
    position: relative;
  }

  .intro-text {
    height: 18px;
    left: 66px;
    right: 1132px;
    top: calc(50% - 18px / 2 - 221px);
  }

  .box-container {
    display: flex;
    box-shadow: 0px 4px 8px rgba(0, 34, 102, 0.1);
    border-radius: 6px;
    background: #ffffff;
    padding: 14px 20px;
    justify-content: space-between;
    align-items: center;

    height: 46px;
  }

  .box-container-show {
    display: flex;
    box-shadow: 0px 0px 0px rgba(0, 34, 102, 0.1);
    border-radius: 6px;
    background: #ffffff;
    padding: 14px 20px;
    justify-content: space-between;
    align-items: center;

    height: 46px;
  }

  .box-container .col,
  .box-container-courses-show .col {
    padding: 0px;
  }

  .box-container .box-container-label,
  .box-container .box-container-data,
  .box-container-courses-show .box-container-label,
  .box-container-courses-show .box-container-data {
    width: max-content;
    min-width: max-content;
  }

  .box-container-label {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;

    color: #475466;
  }

  .box-container-label-courses {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    color: #475466;
    flex-grow: 0;
  }

  .box-container-data {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    color: #98a2b3;
    margin-left: 9px;
  }

  .link-editar {
    display: flex;
    text-decoration-line: underline;
    padding-left: 7px;
    padding-top: 12px;
  }
`;

export const ColCoursesLabel = styled(Row)``;

export const RowCourses = styled(Row)``;

export const ContentBotton = styled.section`
  padding-left: 45%;
  text-align: right;
`;

export const CreateActivelButton = styled.button.attrs(() => ({
  type: 'button',
}))`
  background: #4a90e2;
  border-radius: 50px;
  width: 320px;
  border: 0;
  color: #ffffff;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  padding: 13px;

  margin-top: 5px;

  &:hover {
    background: ${shade(0.05, '#4a90e2')};
    color: ${shade(0.05, '#ffffff')};
  }
`;
export const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const Container = styled.main`
  display: flex;
  margin: auto;
  flex: 1;
  /*animation: ${appearFromLeft} 1s;*/

  @media ${device.sm} {
    max-width: 540px;
  }

  @media ${device.md} {
    max-width: 720px;
  }

  @media ${device.lg} {
    max-width: 960px;
  }

  @media ${device.xl} {
    max-width: 1230px;
  }
`;

export const FormContainer = styled(Container)`
  animation: ${appearFromLeft} 1s;
  display: flex;
  flex: 1;
`;
